import { useLocalization } from "@progress/kendo-react-intl";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { AccessToken } from "../../../config/AccessToken";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { ListView, ListViewEvent, ListViewFooter, ListViewHeader, ListViewItemProps } from "@progress/kendo-react-listview";
import { SvgIcon } from "@progress/kendo-react-common";
import { Avatar } from "@progress/kendo-react-layout";
import { checkboxIcon, saveIcon, searchIcon, starIcon } from "@progress/kendo-svg-icons";
import { TextBox, TextBoxChangeEvent, TextBoxProps } from "@progress/kendo-react-inputs";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn, GridCustomCellProps, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { loadingPanel } from "../../LoadingPanel";
import { NotificationGroup, Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";




/**
 * ConfigDevicesBinding is a React component that manages the binding of devices
 * within a list view. It handles the fetching and displaying of devices,
 * device bindings, and groups, as well as user interactions such as device
 * selection, filtering, and updating device information. The component
 * communicates with a server for data retrieval and updating using access tokens
 * for authorization. It also provides a user interface for managing device
 * bindings, including a search feature and save functionality.
 */

export const ConfigDevicesBinding = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;


    const [devicesList, setDevicesList] = useState<any>(null);
    const [counterActiveDevices, setCounterActiveDevices] = useState(null);
    //const [counterInactiveDevices, setCounterInactiveDevices] = useState(null);
    const [deviceToDelete, setDeviceToDelete] = useState<any>(null);
    const [deviceMacSelected, setDeviceMacSelected] = useState('');
    const [deviceTypeName, setDeviceTypeName] = useState('');
    const [devicebattery, setDevicebattery] = useState('');
    const [deviceNameSelected, setDeviceNameSelected] = useState<TextBoxProps["value"]>('');

    const [listViewData, setListViewData] = useState(devicesList);

    const [devicesBinding, setDevicesBinding] = useState<any>([]);
    const [lastFromBinding, setLastFromBinding] = useState<any>('');
    const [lastToBinding, setLastToBinding] = useState<Date | any>();


    const [visible, setVisible] = useState<boolean>(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);


    const localizationService = useLocalization();

    const [instance, accessTokenRequest] = AccessToken();

    let languageId = localStorage.getItem('languageId');

    const [loading, setLoading] = useState(false);

    const getDeviceList = async () => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/device/list`, {
                headers
            })
                .then((res) => {
                    const data: any = res?.data
                    setCounterActiveDevices(data?.data?.length);
                    setDevicesList(data?.data);
                    //setDevicesList(data?.data.splice(0, 12));                    
                    setLoading(false);
                }).catch((data) => {
                    setError(data?.message);
                if (!error) {
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                    setLoading(false);
                });
        }
    }

    //  call API on page load
    useEffect(() => {
        getDeviceList()
    }, [])

    const getDevicesBindingList = async (deviceMac: boolean) => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/device/bindings/${deviceMac}`, {
                headers
            })
                .then((res) => {
                    const data: any = res?.data?.data

                    if(data.length > 0) {
                        
                        data?.forEach((binding: any) => {

                            if (binding?.startDate == null) {
                                binding.startDate = localizationService.toLanguageString('binding.date_not_found', 'NOT_FOUND')
                                return
                            } else {
                                binding.startDate = binding?.startDate?.split('T')[0]
                            }

                            if (binding?.endDate == null) {
                                binding.endDate = localizationService.toLanguageString('binding.date_not_found', 'NOT_FOUND')
                                return
                            } else {
                                binding.endDate = binding?.endDate?.split('T')[0]
                            }
                        })

                        data[0].recent = 'recent'

                        setDevicesBinding(data);

                        let lastDataBinding: any = data[0]?.startDate
                        setLastFromBinding(lastDataBinding);

                        let toDataBinding: any = data[0]?.endDate
                        setLastToBinding(toDataBinding);
                    }else{
                        setDevicesBinding([]);
                    }
                    setLoading(false);
                }).catch((data) => {

                    setErrorMessage(data?.message)
                    setError(data?.message);
                    if (!errorMessage) {
                        setTimeout(() => {
                            setErrorMessage(false);
                        }, 5000);
                    }
                    setLoading(false);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const onFilterChange = (ev: any) => {
        let value = ev.value;
        let newData = devicesList.filter((device: any) => {
            let match = false;
            for (const property in device) {
                //if (
                //    device[property]?.toString() &&
                //    device[property]
                //        ?.toString()
                //        .toLocaleLowerCase()
                //        .indexOf(value.toLocaleLowerCase()) >= 0
                //) 
                if ((device['name']?.toString() && device['name']?.toString().toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0) || (device['mac']?.toString() && device['mac']?.toString().toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0) )
                {
                    match = true;
                }
            }
            return match;
        });
        setListViewData(newData);
    };

    const MyHeader = () => {
        return (
            <>
                <ListViewHeader
                    style={{ color: "#018CA5", fontSize: 14 }}
                    className="pl-3 pb-2 pt-2"
                >
                    {localizationService.toLanguageString('configuration.devices.devices_list', 'NOT FOUND')} ({counterActiveDevices})
                </ListViewHeader>
            </>
        );
    };

    const MyFooter = () => {
        let messages = 0;
        devicesList.map((i: any) => {
            messages = messages + i.messages;
        });
        return (
            <ListViewFooter
                style={{ color: "#018CA5", fontSize: 14 }}
                className="pl-3 pb-2 pt-2"
            >
                {/*{counterActiveDevices} {localizationService.toLanguageString('configuration.devices.active_devices', 'NOT_FOUND')}*/}
            </ListViewFooter>
        );
    };

    const toggleDialog = (item?: any) => {
        setDeviceToDelete(item);
        setVisible(!visible);
    };

    const deleteDevice = () => {
        console.log(deviceToDelete);
    }

    // called on click device
    const getDeviceInfoOnClick = (item: any) => {
        setDeviceMacSelected(item.mac);
        setDeviceNameSelected(item.name);
        setDeviceTypeName(item.deviceTypeName);
        setDevicebattery(item.battery);
        getGroupList();
        getDevicesBindingList(item.mac)
        //setDeviceVersionSelected(item.deviceVersion); // if exist...TBD
    }

    const DevicesRender = (props: ListViewItemProps) => {
        let item = props.dataItem;
        return (
            <div
                className="k-listview-item row p-2 border-bottom align-middle"
                style={{ margin: 0 }}
            >
                {/*<div className="col-2" onClick={() => { toggleDialog(item) }} >*/}
                <div
                    className="col-2"
                    style={{ alignContent: 'center' }}
                >
                    <Avatar
                        type="image"
                        style={{
                            //cursor: 'pointer', 
                            background: "#018CA5"
                        }}
                    >
                        <SvgIcon icon={checkboxIcon} style={{ verticalAlign: 'baseline', margin: '8px' }} />
                    </Avatar>
                </div>
                <div className="col-9" style={{ cursor: 'pointer', color: "#018CA5" }} onClick={() => { getDeviceInfoOnClick(item) }}>
                    <h2
                        className="device-binding-name-h2"
                        style={{
                            fontSize: 16,
                            padding: '10px',
                            cursor: 'pointer',
                            textTransform: 'uppercase'
                        }}
                    >
                        {item.name} ({item.mac})
                    </h2>
                </div>
            </div>
        );
    };

    const scrollHandler = (event: ListViewEvent) => {
        const e = event.nativeEvent;
        if (e.target.scrollTop + 10 >= e.target.scrollHeight - e.target.clientHeight) {
            const moreData = devicesList.splice(0, 6);
            if (moreData.length > 0) {
                setDevicesList(devicesList.concat(moreData));
            }
        }
    };

    const handleChangeDeviceName = useCallback((event: TextBoxChangeEvent) => {
        setDeviceNameSelected(event.target.value);
    }, []);

    const getGroupList = async () => {

        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/group/list`, { headers })
                .then((res) => {
                    const data = res.data.data
                    setLoading(false);
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const CustomCell = (props: GridCustomCellProps) => {
        return (
            <td
                colSpan={1}
                style={{
                    fontSize: '14px',
                }}
            >
                {props.children}
            </td>
        );

    };

    const saveDevice = async (deviceMac: any, deviceName: any, startDate: any, endDate: any) => {
        
        setLoading(true);

        const commonOperations = async (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            const params = {
                deviceMac,
                deviceName,
                //startDate
                //endDate
            };
            try {
                await axios.post(`${SERVER_URL}/device/binding/update`, params, { headers })
                setLoading(false)
            } catch (error: any) {
                setErrorMessage(error);
                if (error) {
                    setTimeout(() => {
                        setErrorMessage(false);
                    }, 3000);
                }
                setLoading(false)
            }
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken)
            })
        }
    }

    const closeBinding = (deviceSelected: any) => {

        devicesBinding.map((device: any) => {
            if (device.startDate === deviceSelected.startDate) {
                device.endDate = new Date();
            }
        })
        setDevicesBinding([...devicesBinding]);

        updateDeviceBinding(deviceSelected)
    }

    const formatDateFromIsoToString = (isoString:any) => {
        const date = new Date(isoString);
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    const updateDeviceBinding = async (deviceSelected: any) => {

        setLoading(true);

        let newDevice: any = JSON.parse(JSON.stringify(deviceSelected))
        var endDate = formatDateFromIsoToString( newDevice.endDate)

        const params = {
            'deviceMac': newDevice.mac,
            'deviceName': newDevice.serial,
            'startDate': newDevice.startDate,
            'endDate': endDate
        };

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.post(`${SERVER_URL}/device/binding/update`, params, { headers })
                .then(() => {
                    getDevicesBindingList(newDevice.mac)
                    setLoading(false);
                }).catch((data) => {
                    setLoading(false);
                    setError(data?.message);
                });
        }

        if (sessionStorage.getItem('accessToken') != null) {
            let accessToken = sessionStorage.getItem('accessToken');
            commonOperations(accessToken);
        } else {
            await instance.initialize();
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }
    }

    const CloseBindingIconGrid = (propsGrid: GridCustomCellProps) => {
        const deviceSelected = propsGrid?.dataItem

        if(deviceSelected != null && deviceSelected?.recent == 'recent'){
            return (
                <td
                    className="k-icon k-font-icon k-i-unlink"
                    style={{ zoom: '1.5', cursor: 'pointer', color: '#018CA5', textAlign: 'center', width: '80%' }}
                    onClick={() => closeBinding(deviceSelected)}
                    title={localizationService.toLanguageString('configuration.devices.close_binding', 'NOT FOUND')}
                >
                </td>
            )
        } else {
            return (<td ></td>)
        }
    };

    return (
        <>
            {loading && loadingPanel}
            <NotificationGroup
                style={{
                    right: 0,
                    bottom: 0,
                    position: "absolute",
                    alignItems: "flex-start",
                    flexWrap: "wrap-reverse",
                }}
            >
                <Fade enter={true} exit={true}>                    
                    {errorMessage && (
                        <Notification
                            type={{ style: "error", icon: true }}
                            onClose={() => setErrorMessage(false)}
                        >
                            <span>{errorMessage}</span>
                        </Notification>
                    )}
                </Fade>
            </NotificationGroup>
            {devicesList?.length > 0 &&
                <div
                    className={deviceMacSelected && "flex-parent-element-device-binding"}
                >

                    {/* left panel */}
                    <div
                        className="flex-left-child-element"
                        style={{
                            width: "40%",
                            background: "#F7F7F7",
                            paddingLeft: "5%"
                        }}
                    >
                        <div
                            className="k-listview-item row p-2 align-middle"
                            style={{ display: 'block', margin: 0, }}
                        >
                            <fieldset style={{ display: 'flex' }}>
                                {/*{localizationService.toLanguageString('search', 'NOT FOUND')}:*/}
                                <TextBox
                                    style={{
                                        border: '2px solid #ccc',
                                        boxShadow: 'inset 0px 0px 5px 0px rgba(0,0,0,0.13)',
                                        marginBottom: '10px',
                                    }}
                                    onChange={onFilterChange}
                                    placeholder={localizationService.toLanguageString('configuration.devices.search_device', 'NOT FOUND')}
                                    prefix={() => (
                                        <SvgIcon icon={searchIcon} svgStyle={{ margin: '20px -5px 0px 5px' }} />
                                    )}
                                />
                            </fieldset>
                        </div>
                        <ListView
                            data={listViewData ?? devicesList}
                            item={DevicesRender}
                            style={{
                                background: "#F7F7F7",
                                //height: `${deviceMacSelected && '30%'}`
                            }}
                            header={MyHeader}
                            footer={MyFooter}
                            onScroll={scrollHandler}
                        />
                        {visible && (
                            <Dialog
                                title={localizationService.toLanguageString('configuration.devices.remove_device', 'NOT FOUND')}
                                onClose={toggleDialog}
                            >
                                <div>
                                    <button
                                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                        style={{
                                            margin: '10px',
                                            width: '80px'
                                        }}
                                        onClick={toggleDialog}
                                    >
                                        {localizationService.toLanguageString('no', 'NOT FOUND')}
                                    </button>
                                    <button
                                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                        style={{
                                            margin: '10px',
                                            width: '80px'
                                        }}
                                        onClick={() => {
                                            if (visible) {
                                                toggleDialog()
                                                deleteDevice()
                                            }
                                        }}
                                    >
                                        {localizationService.toLanguageString('yes', 'NOT FOUND')}
                                    </button>
                                </div>
                            </Dialog>
                        )}
                    </div>

                    {/* right panel */}
                    {deviceMacSelected != '' &&
                        //<div className="flex-right-child-element" style={{ width: "35%", background: '#ffffff' }}>
                        <div
                            style={{
                                margin: '0 auto',
                                alignContent: 'center',
                                height: '100%',
                                paddingLeft: '1rem'
                            }}
                        >
                            {/* mac + name */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <fieldset>
                                    <h1 className="k-h2" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.mac', 'NOT_FOUND')}</h1>
                                    <h5 className="k-h5" style={{ color: '#018CA5' }}>{deviceMacSelected != '' ? deviceMacSelected : localizationService.toLanguageString('configuration.devices.no_mac', 'NOT_FOUND')}</h5>

                                    <hr style={{ border: '1px solid #018CA5', width: '100%' }} />

                                    <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.name', 'NOT_FOUND')}</div>
                                    <TextBox
                                        style={{ color: "#018CA5" }}
                                        value={deviceNameSelected != '' ? deviceNameSelected : ''}
                                        onChange={handleChangeDeviceName}
                                        placeholder={localizationService.toLanguageString('configuration.devices.enter_device_name', 'NOT_FOUND')}
                                    />
                                </fieldset>
                            </div>

                            <br />

                            {/* type */}
                            <div className="k-listview-item row p-1 align-middle">
                                <div className="col-2" >
                                    <Avatar type="image" style={{ background: "#018CA5" }}>
                                        <SvgIcon icon={starIcon} style={{ verticalAlign: 'baseline', margin: '8px' }} />
                                    </Avatar>
                                </div>
                                <div className="col-9" >
                                    <h1
                                        style={{ fontSize: 16, color: "#018CA5", verticalAlign: 'bottom', display: 'inline-flex' }}
                                        className="text-uppercase"
                                    >
                                        {deviceTypeName != '' ? deviceTypeName : ''}
                                    </h1>
                                </div>
                            </div>

                            <br />

                            {/* battery */}
                            {/*<div className="k-listview-item row p-1 align-middle">
                                <div className="col-9" >
                                    <div className="k-h5" style={{ color: '#018CA5' }}>
                                        {localizationService.toLanguageString('configuration.devices.battery', 'NOT_FOUND')}
                                        <h1
                                            style={{ fontSize: 16, color: "#018CA5", marginLeft: '20px', display: 'inline' }}
                                            //className="text-uppercase"
                                        >
                                            {devicebattery != '' ? devicebattery + '%' : 'n/d'}
                                        </h1>
                                    </div>
                                </div>
                            </div>*/}

                            <br />

                            {/* from/to */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <fieldset style={{ display: 'flex' }}>
                                    <div style={{ flex: 2 }}>
                                        <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.from', 'NOT_FOUND')}</div>
                                        <h1
                                            style={{ fontSize: 16, color: "#018CA5", verticalAlign: 'bottom', display: 'inline-flex' }}
                                            className="text-uppercase"
                                        >
                                            {lastFromBinding ?? ''}
                                        </h1>
                                    </div>
                                    <div>
                                        <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.to', 'NOT_FOUND')}</div>
                                        <h1
                                            style={{ fontSize: 16, color: "#018CA5", verticalAlign: 'bottom', display: 'inline-flex' }}
                                            className="text-uppercase"
                                        >
                                            {lastToBinding ?? ''}
                                        </h1>
                                    </div>
                                </fieldset>


                            </div>

                            <br />

                            {/* bindings */}
                            <div
                                className="k-listview-item row p-1 align-middle"
                                style={{ display: 'block', margin: 0 }}
                            >
                                <div className="k-h5" style={{ color: '#018CA5' }}>{localizationService.toLanguageString('configuration.devices.all_bindings', 'NOT_FOUND')}</div>

                            </div>
                            
                            {devicesBinding.length > 0 &&
                            <Grid
                                style={{ display: 'inline-table', margin: '.5rem' }}
                                data={devicesBinding}    
                                className='k-grid k-grid-md grid-bindings-custom'                            
                            >
                                <GridColumn
                                    field="serial"
                                    title={localizationService.toLanguageString('configuration.devices.name', 'NOT_FOUND')}
                                    width="150px"
                                />
                                <GridColumn
                                    field="startDate"
                                    title={localizationService.toLanguageString('configuration.devices.from', 'NOT_FOUND')}
                                    format='{0:dd/MM/yyyy HH:mm:ss}'
                                    width="150px"
                                    cells={{ data: CustomCell }}
                                />
                                <GridColumn
                                    field="endDate"
                                    title={localizationService.toLanguageString('configuration.devices.to', 'NOT_FOUND')}
                                    format='{0:dd/MM/yyyy HH:mm:ss}'
                                    width="150px"
                                    cells={{ data: CustomCell }}
                                />
                                <GridColumn
                                    field="closeBinding"
                                    title={localizationService.toLanguageString('configuration.devices.close_binding', 'NOT_FOUND')}
                                    width="140px"
                                    cells={{ data: CloseBindingIconGrid }}
                                />                                
                            </Grid>
            }
           
                            <br />

                            {/* save button */}
                            <div className="k-listview-item row p-4">
                                <Button
                                    themeColor={"primary"}
                                    className="save-devices-management-button"
                                    svgIcon={saveIcon}
                                    onClick={() => saveDevice(deviceMacSelected, deviceNameSelected, lastFromBinding, lastToBinding)}
                                >
                                    {localizationService.toLanguageString('configuration.devices.save', 'NOT_FOUND')}
                                </Button>
                            </div>

                        </div>
                    }
                </div>
            }
        </>
    )
}